// src/pages/orders/components/ShopSelectionSection.jsx
import React from 'react';
import { Store, ChevronDown, Hash, Lock } from 'lucide-react';
import { useLocalization } from '../../../contexts/LocalizationContext';
import styles from './ShopSelectionSection.module.css';

const ShopSelectionSection = ({
  selectedShop,
  userShops,
  onShopChange,
  orderNumberPreview,
  error,
  isReadOnly = false,
  compact = false
}) => {
  const { t } = useLocalization();

  // Compact mode: read-only just shows the shop name inline
  if (isReadOnly) {
    return (
      <div className={styles.shopSelectionContent}>
        <div className={`${styles.readOnlyRow} ${compact ? styles.compactRow : ''}`}>
          <div className={styles.readOnlyShopName}>
            <Store size={15} className={styles.readOnlyIcon} />
            <span>{selectedShop?.name}</span>
            {selectedShop?.type && (
              <span className={styles.shopTypeBadge}>{selectedShop.type}</span>
            )}
          </div>
          {orderNumberPreview && (
            <div className={styles.orderNumBadge}>
              <Hash size={13} />
              <span>{orderNumberPreview}</span>
            </div>
          )}
        </div>
        <p className={styles.readOnlyNote}>Shop cannot be changed after order creation</p>
      </div>
    );
  }

  // Compact create mode: just the dropdown
  return (
    <div className={styles.shopSelectionContent}>
      <div className={styles.formGroup}>
        <label htmlFor="shopSelect">
          {t('ecomOrders.selectShop')} *
        </label>
        <div className={styles.selectWrapper}>
          <Store className={styles.selectIcon} size={16} />
          <select
            id="shopSelect"
            value={selectedShop?.id || ''}
            onChange={(e) => onShopChange(parseInt(e.target.value))}
            className={`${styles.select} ${error ? styles.error : ''}`}
            required
          >
            <option value="">{t('ecomOrders.selectShop')}</option>
            {userShops.map(shop => (
              <option key={shop.id} value={shop.id}>
                {shop.name} ({shop.type})
              </option>
            ))}
          </select>
          <ChevronDown className={styles.selectArrow} size={16} />
        </div>
        {error && <span className={styles.errorText}>{error}</span>}
      </div>
    </div>
  );
};

export default ShopSelectionSection;